// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as AddSecondaryNumberApiModel from "../api-model/AddSecondaryNumberApiModel.bs.js";

function decodeApiModel(json) {
  return {
          message: json.message,
          request_id: json.request_id
        };
}

function execute(json) {
  return decodeApiModel(DeccoUtils$Catalyst.resolveResult(AddSecondaryNumberApiModel.t_decode(json), "AddSecondaryNumbeEntityMapper.re"));
}

export {
  decodeApiModel ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
